'use strict';

var dialog = require('./dialog');
var util = require('./util');
var progress = require('./progress');
var _ = require('lodash');
var global = require('./global');
var googletaglinchpin = require('int_googletagmanager/googletaglinchpin');

var configurator = {
	data: null,
	customerData: {
		'selections': []
	},
	init: function () {
		initData();
		initializeEvents();
	}
};

var editStatuses = {
	OK: 'OK',
	ERROR: 'ERROR',
	CANCELED: 'CANCELED'
};

var saveResultConfigSync = _.debounce(saveResultConfig, 300);
var updateConfiguratorViewSync = _.debounce(updateConfiguratorView, 300);

/*
 * Parse data from object printed on page
 * and prepare sorted list of selections available
 */
function initData() {
	var data = $('#configData').data('config');
	data.selectionsList = [];
	data.pidsMapping = {}; // global object, similar to productIDsMapping

	// setup edit config
	var editData = $('#resultConfig').data('edit-data');
	configurator.editResult = editData;

	// The logic follows backend logic to decrease object data that transfer.
	// Don't remove the following logic!
	// Provide selection in a usefull list with supporting properties
	for (var i = 0, stepData; i < data.steps.length; i++) {
		stepData = data.steps[i];
		for (var j = 0, selectionID; j < stepData.selection.length; j++) {
			selectionID = stepData.selection[j];
			var selectionConfig = data.selections[selectionID];
			data.selectionsList.push(selectionConfig);
		}
	}

	configurator.data = data;
	window.configurator = configurator;

	// push initial selection
	var stepData = configurator.data.steps[0];
	var nextSelection = getNextSelection();
	var selectionID = nextSelection.id || stepData.selection[0];
	updateSelection(stepData.id, selectionID);
}

function getResultConfig () {
	return configurator.customerData;
}

function getEditConfig () {
	return configurator.editResult;
}

/*
 * Build list of product groups and options picked based on customer selections
 */
function getQualifierSelections() {
	var customerSelectionData = getResultConfig();
	var selectedQualifiers = [];

	// Add editKey as qualifier id
	var editData = getEditConfig();
	if (editData && editData.editKey) {
		selectedQualifiers.push(editData.editKey);
	}

	// append all options and product groups
	for (var i = 0, customerSelection; i < customerSelectionData.selections.length; i++) {
		customerSelection = customerSelectionData.selections[i];
		if (!customerSelection.option) {
			continue;
		}

		var optionConfig = getConfigData(configurator.data.constants.configTypeOption, customerSelection.option);
		selectedQualifiers.push(customerSelection.option);
		for (var productGroupID in optionConfig.productGroups) {
			selectedQualifiers.push(productGroupID);
		}
	}
	configurator.availableQualifiers = selectedQualifiers;
	return selectedQualifiers;
}

/*
 * Method called after every configurator results update
 */
function saveResultConfig () {
	var currentResult = getResultConfig();
	var updateURL = $('#resultConfig').data('update-url');
	progress.show($('.info_and_summary'));
	$.ajax({
		url: updateURL,
		type: 'POST',
		dataType:'json',
		contentType: 'application/json',
		data: JSON.stringify(currentResult),
		success: function (response) {
			if (response.error) {
				return console.error(response);
			}
			updateSummary();
		},
		error: console.error
	});
}

/*
 * Method to build selection object
 * and update it with pre-selected options and items
 * and clean up invalid lines
 */
function prepareSelectionData(customerSelection) {

	// check for preselected options for this selection
	if (!customerSelection.option) {
		var selectionConfig = getConfigData(configurator.data.constants.configTypeSelection, customerSelection.selection);
		for (var i = 0, optionID, option; i < selectionConfig.options.length; i++) {
			optionID = selectionConfig.options[i];
			option = getConfigData(configurator.data.constants.configTypeOption, optionID);
			if (option['pre-selected']) {
				customerSelection.option = optionID;
			}
		}
	}

	// check option for any preselected products
	var itemsNumber = Object.keys(customerSelection.items).length;
	if (customerSelection.option && !itemsNumber) {
		var preselectedItems = getPreselectItems();
		console.debug('preselectedItems', preselectedItems);
		var optionConfig = getConfigData(configurator.data.constants.configTypeOption, customerSelection.option);
		for (var productGroupID in optionConfig.productGroups) {
			var quantity = optionConfig.productGroups[productGroupID];
			var productGroup = getConfigData(configurator.data.constants.configTypeProductGroup, productGroupID);

			// add all items
			if (productGroup.type === configurator.data.constants.productGroupTypeAll) {
				for (var j = 0, pid; j < productGroup.pids.length; j++) {
					pid = productGroup.pids[j];
					customerSelection.items[pid] = quantity;
				}
				continue;
			}

			// check for items preselected
			for (var productID in preselectedItems) {
				var quantity = preselectedItems[productID];
				var mappedID = configurator.data.pidsMapping[productID];
				if (productGroup.pids.indexOf(productID) < 0 &&
					productGroup.pids.indexOf(mappedID) < 0) {
					continue;
				}
				customerSelection.items[productID] = quantity;
			}
		}
	}

	// check items in object and remove if quantity is 0
	// also check amount to be within the limit, if such set
	if (itemsNumber) {
		var selectedOptionData = getConfigData(configurator.data.constants.configTypeOption, customerSelection.option);
		for (var productGroupID in selectedOptionData.productGroups) {
			var productGroup = getConfigData(configurator.data.constants.configTypeProductGroup, productGroupID);
			var groupQuantity = selectedOptionData.productGroups[productGroupID];
			var itemsQuantity = 0;
			for (var productID in customerSelection.items) {
				if (!isItemInProductGroup(productID, productGroup)) {
					continue;
				}

				// check if we feet the size of selections, otherwise we will cut the number
				var itemQuantity = customerSelection.items[productID];
				if ((groupQuantity - itemsQuantity - itemQuantity) < 0) {
					itemQuantity = groupQuantity - itemsQuantity;
					customerSelection.items[productID] = itemQuantity;
				}
				itemsQuantity += itemQuantity;
			}
		}
		// clean up zeroes
		for (var pid in customerSelection.items) {
			if (customerSelection.items[pid] <= 0) {
				delete customerSelection.items[pid];
			}
		}
	}
}

/*
 * Get selection data for given step and selection IDs
 */
function getSelection(stepID, selectionID) {
	var currentResult = getResultConfig();
	for (var i = 0, selectionData; i < currentResult.selections.length; i++) {
		selectionData = currentResult.selections[i];
		if (selectionData.step === stepID && selectionData.selection === selectionID) {
			return selectionData;
		}
	}
}

/*
 * When conflicting selections present, reset selection branch that is not available
 */
function resetUnavailableSelections() {
	var currentResult = getResultConfig();
	for (var i = 0, selectionData; i < currentResult.selections.length; i++) {
		selectionData = currentResult.selections[i];
		if (!isSelectionQualified(selectionData.selection)) {
			currentResult.selections.splice(i);
			break;
		}
	}
}

/*
 * Update customer selections with new action
 */
function updateSelection(stepID, selectionID, optionID, items) {
	console.debug('updateSelection', stepID, selectionID, optionID, items);

	var customerSelection = getSelection(stepID, selectionID);
	var currentResult = getResultConfig();
	var isNewSelection = false;

	// push new selection into stored list
	if (!customerSelection) {
		customerSelection = {};
		currentResult.selections.push(customerSelection);
		isNewSelection = true;
	} else {
		isNewSelection = !customerSelection.option && optionID;
	}

	currentResult.activeStep = stepID;
	customerSelection.step = stepID;
	customerSelection.selection = selectionID;
	customerSelection.option = optionID;
	customerSelection.items = items || {};
	customerSelection.groupsCompletion = {};
	customerSelection.completed = false;

	// determine if options or items should be added automatically
	prepareSelectionData(customerSelection);
	updateSelectionComplition(customerSelection);
	console.debug('updateSelectionData', customerSelection, isNewSelection);

	// update selections data
	resetUnavailableSelections();

	// save to server
	saveResultConfigSync();
	trackStepChange();

	// load more product group content
	loadProductsContent();

	// update view
	updateConfiguratorView();

	// check complition and show next available in current step
	if (customerSelection.completed) {
		triggerNextAvailableSelection(isNewSelection);
	}

	return customerSelection;
}

// tracking step via url appending functionality
function trackStepChange () {
	if (!configurator.data.addStepToURL) {
		return;
	}

	var currentResult = getResultConfig();
	var stepConfig = getConfigData(configurator.data.constants.configTypeStep, currentResult.activeStep);
	var newStepParam = '';
	if (stepConfig && stepConfig.urlExtention && stepConfig.urlExtention.step) {
		newStepParam = stepConfig.urlExtention.step;
	}

	// check current value
	var currentURL = new URL(window.location.href);
	var stepParam = currentURL.searchParams.get('step');
	if (!newStepParam || stepParam === newStepParam) {
		return;
	}

	currentURL.searchParams.set('step', newStepParam);
	window.history.pushState(null, null, currentURL);
}

/*
 * Method to update tool tip container
 * when no value provided it will be hidden
 */
function updateTooltip (message) {
	var $blockInfo = $('.tooltip-container');
	var $msgSection = $blockInfo.find('.information');
	if (!message) {
		$blockInfo.hide();
		return;
	}
	$msgSection.text(message);
	$blockInfo.show();
}

/*
 * Load product groups section via ajax call, to reduce initial page load and amount of remote includes
 */
function loadProductsContent () {
	// check product groups with selections to be qualified
	$('.product-group[data-load-url]:not(.loading, .loaded)').each(function () {
		if (!isSelectionQualified($(this).closest('[selection-id]').attr('selection-id'))) {
			return;
		}
		var url = $(this).data('load-url');
		$(this).addClass('loading');
		$(this).load(url, function () {
			$(this).removeClass('loading').addClass('loaded');
			updateConfiguratorViewSync();
		});
	});
}

/*
 * Trigger events required to update product group content
 * those events should be safe to call at any time
 */
function updateProductGroupContent () {

	// update interactions presented based on qty required
	$('.product-group.loaded').each(function () {
		var $productGroup = $(this);
		var productGroupQty = parseInt($productGroup.attr('group-qty'));
		if (productGroupQty === 1) {
			$productGroup.find('.interactions').removeClass('multiple').addClass('single');
		} else {
			$productGroup.find('.interactions').removeClass('single').addClass('multiple');
		}

		// update total content
		$productGroup.find('.preview-control_info .total').text(productGroupQty);
	});

	// update next/prev buttons status based on product group siblings available
	var groupModalSelector = '.product-group.visible[group-style="modal-grid"]';
	var $modalProductGroups = $(groupModalSelector);
	$modalProductGroups.each(function () {
		var $siblingGroups = $(this).siblings(groupModalSelector);
		var $incompleteGropus = $siblingGroups.filter(':not(.completed)');
		// allow next for non-last groups when selections completed
		if (($incompleteGropus.length && $(this).hasClass('completed')) ||
			(!$incompleteGropus.length && !$(this).is(':last-child'))) {
			$(this).find('.next-selection-btn').removeClass('disabled');
		}
		// for back action, checking completed groups only
		$siblingGroups = $siblingGroups.filter('.completed');
		if ($siblingGroups.length) {
			$(this).find('.prev-selection-btn').removeClass('disabled');
		}
	});

	// collect product mapping to have alternative ids
	$('.product[product-id][pid]').each(function () {
		var masterID = this.getAttribute('product-id');
		var variationID = this.getAttribute('pid');
		configurator.data.pidsMapping[masterID] = variationID;
		configurator.data.pidsMapping[variationID] = masterID;
	});

	initSlick();
}

/*
 * Initialize all slick carousels on the page in a safe way
 */
function initSlick() {

	// init slider for images selection with related events handling
	$('.product .slider-nav').not('.slick-initialized').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		focusOnSelect: true
	}).on('afterChange', function (event, slick, currentSlide) {
		var $productBlock = slick.$slider.parents('.product');
		var $images = $productBlock.find('.main-image');
		$images.hide();
		$($images.get(currentSlide || 0)).show();
	}).slick('slickGoTo', 0);

	$('.product-group.loaded .carousel').not('.slick-initialized').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 650,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

	// check dynamic slider to be inited for elements exceeding width of container
	$('.dynamic-carousel .options').not('.slick-initialized').each(function () {
		var $tiles = $(this).children();

		// while hidden width going to be 0, so we should wait for it to be displayed
		var tileWidth = $tiles.first().width();
		var containerWidth = $(this).width();
		if (containerWidth <= 0) {
			return;
		}
		var tilesPerSlot = Math.floor(containerWidth / tileWidth);
		var slidesToShow = $tiles.length > tilesPerSlot ? tilesPerSlot : $tiles.length;
		var isSlider = $tiles.length > slidesToShow;
		if (!isSlider) {
			return;
		} else {
			$(this).addClass('options-slider');
		}
		if (slidesToShow < 2) {
			//adds class for special animation when sliderToShow = 1
			$(this).addClass('only-one');
		}
		$(this).slick({
			infinite: false,
			slidesToShow: slidesToShow,
			slidesToScroll: 1,
			dots: false,
			arrows: isSlider
		});
	});

	$('.chosen-items-slider').not('.slick-initialized').each(function () {
		var $tiles = $(this).children();
		var tileWidth = $tiles.first().width();
		var containerWidth = $(this).width();
		if (containerWidth <= 0 || tileWidth <= 0) {
			return;
		}

		var tilesPerSlot = Math.floor(containerWidth / tileWidth);
		var slidesToShow = $tiles.length > tilesPerSlot ? tilesPerSlot : $tiles.length;
		var isSlider = $tiles.length > slidesToShow;
		if (!isSlider) {
			return;
		}

		$(this).slick({
			infinite: false,
			slidesToShow: slidesToShow,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			responsive: [
				{
					breakpoint: 484,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});
	});

	// trigger resize to update width
	$('.slick-initialized').slick('setDimensions');
}
function initializeEvents () {
	$('#summaryContent').on('click', '.summary-step-block:not(.active) .header', function () {
		var $block = $(this).parent('.summary-step-block');
		$block.toggleClass('visible');
	});

	$('.selection').on('change', 'input[name="option"], select[name="option"]', function () {
		// update selection with step, selection and option ids
		var stepID = $(this).closest('[step-id]').attr('step-id');
		var selectionID = $(this).closest('[selection-id]').attr('selection-id');
		var optionID = $(this).val();
		var customerSelection = getSelection(stepID, selectionID);
		// prevent trigger, when inputs are just updated with current values
		if (customerSelection && customerSelection.option === optionID) {
			return;
		}
		updateSelection(stepID, selectionID, optionID);
	});

	// handle move to previous step
	$('.configurator-container').on('click', '.prev-step-btn', function (e) {
		e.preventDefault();

		var confirmationContentID = $(this).data('modal-content');
		// continue to previous step
		if (!confirmationContentID) {
			return moveToPreviousStep();
		}

		// show confirmation modal
		dialog.open({
			url: util.appendParamsToUrl(Urls.includeContentAsset, {cid: confirmationContentID}),
			options: {
				buttons: [
					{
						text: Resources.CANCEL_AND_CLOSE,
						'class':'btn-close',
						click: function () {
							dialog.close();
						}
					},
					{
						text: Resources.REMOVE_AND_GO_BACK,
						'class':'button-gray approve-button',
						click: function () {
							dialog.close();
							moveToPreviousStep();
						}
					}
				],
				dialogClass: 'to-prev-step-dialog',
				title: $(this).data('modal-title')
			},
			callback: function () {
				var $modal = $('.to-prev-step-dialog');
				var $backBtn = $modal.find('.pseudo-back');
				if ($backBtn.length) {
					$modal.find('.approve-button').hide();
					$backBtn.on('click', function () {
						$modal.find('.approve-button').click();
					});
				}
			}
		});
	});

	// handle selected product option switch
	$('.product-group[group-type="one-option"]').on('click', '.interactions .option-select', function () {
		var productID = $(this).closest('[product-id]').attr('product-id');
		var stepID = $(this).closest('[step-id]').attr('step-id');
		var selectionID = $(this).closest('[selection-id]').attr('selection-id');
		var productGroupID = $(this).closest('[product-group-id]').attr('product-group-id');

		// reset all items related to that product group, then set qty for selected option
		var currentSelection = getSelection(stepID, selectionID);
		var productGroupConfig = getConfigData(configurator.data.constants.configTypeProductGroup, productGroupID);
		var optionConfig = getConfigData(configurator.data.constants.configTypeOption, currentSelection.option);
		for (var pid in currentSelection.items) {
			if (isItemInProductGroup(pid, productGroupConfig)) {
				currentSelection.items[pid] = 0;
			}
		}

		var quantity = optionConfig.quantity;
		currentSelection.items[productID] = quantity;
		updateSelection(currentSelection.step, currentSelection.selection, currentSelection.option, currentSelection.items);
	});

	// handle quantity change for products inside product groups
	$('#summaryContent, .product-group').on('change', 'input[name="quantity"]', function (e) {
		var quantity = parseInt($(this).val());
		var productID = $(this).closest('[product-id]').attr('product-id');
		var stepID = $(this).closest('[step-id]').attr('step-id');
		var selectionID = $(this).closest('[selection-id]').attr('selection-id');
		var productGroupID = $(this).closest('[product-group-id]').attr('product-group-id');
		var currentSelection = getSelection(stepID, selectionID);
		var selectedOptionData = getConfigData(configurator.data.constants.configTypeOption, currentSelection.option);
		var groupQuantity = selectedOptionData.productGroups[productGroupID] || selectedOptionData.quantity;
		if (groupQuantity > 0 && quantity > groupQuantity) {
			quantity = groupQuantity;
		}

		console.debug('quantity change', productID, quantity, e);
		currentSelection.items[productID] = quantity;
		updateSelection(currentSelection.step, currentSelection.selection, currentSelection.option, currentSelection.items);
	});

	// handle select button (single item to pick)
	$('.product-group').on('click', '.interactions .select-button', function () {
		var $quantityInput = $(this).closest('.interactions').find('input[name="quantity"]');
		var quantity = parseInt($quantityInput.val());
		// increment or decrement quantity
		if (quantity > 0) {
			$quantityInput.val(0).change();
		} else {
			$quantityInput.val(1).change();
		}
	});

	// handle plus and minus buttons, initially disabling events attached
	$('.interactions .btn-number').off('click');
	$('#summaryContent, .product-group').on('click', '.interactions .btn-number', function () {
		var $quantityInput = $(this).closest('.interactions').find('input[name="quantity"]');
		var quantity = parseInt($quantityInput.val());
		// increment or decrement quantity
		if ($(this).data('type') === 'plus') {
			$quantityInput.val(quantity + 1).change();
		} else {
			$quantityInput.val(quantity - 1).change();
		}
	});

	// handle interactions with products in summary section
	$('#summaryContent').on('click', '.remove-item', function (e) {
		e.preventDefault();
		var productID = $(this).closest('[product-id]').attr('product-id');
		var stepID = $(this).closest('[step-id]').attr('step-id');
		var selectionID = $(this).closest('[selection-id]').attr('selection-id');
		// input selector build using visible product-group, to make sure we do not allow to remove products from previous steps
		var $quantityInput = $('.product-group.visible[step-id="' + stepID + '"][selection-id="' + selectionID + '"]').find('.product[product-id="' + productID + '"] input');
		$quantityInput.val(0).change();
	});

	// handle single item removal from bubles
	$('.product-group').on('click', '.delete-selected', function () {
		var productID = $(this).siblings('[buble-pid]').attr('buble-pid');
		var $productGroup = $(this).closest('.product-group');
		var $product = $productGroup.find('[product-id="' + productID + '"], [pid="' + productID + '"]');
		var $quantityInput = $product.find('input[name="quantity"]');
		var quantity = parseInt($quantityInput.val());
		// decrement quantity
		var result = quantity - 1;
		$quantityInput.val(result).change();
	});

	$('.product-group').on('click', '.toggle-modal', function () {
		$(this).closest('.product-group').toggleClass('modal-active');
		var shadow = '<div class="ui-widget-overlay ui-front" style="z-index: 100;"></div>';
		var $shadowElement = $('.ui-widget-overlay.ui-front');
		var $body = $('body');
		if ($shadowElement.length > 0) {
			$shadowElement.remove();
			$body.removeClass('scrolling-disabled');
		} else {
			$body.append(shadow);
			$body.addClass('scrolling-disabled');
		}
	});

	// handle modal next/back buttons
	$('.product-group').on('click', '.next-selection-btn, .prev-selection-btn', function () {
		if ($(this).hasClass('disabled')) {
			return;
		}

		// define siblings selector, and add completed class requirments in case of back navigation,
		// in case of next navigation - not completed unless entire selection completed
		var groupModalSelector = '.product-group.visible[group-style="modal-grid"]';
		var $productGroup = $(this).closest('.product-group');
		var lookingNext = $(this).hasClass('next-selection-btn');
		var $siblingGroups = $productGroup.siblings(groupModalSelector);
		if (lookingNext) {
			groupModalSelector += $siblingGroups.filter(':not(.completed)').length ? ':not(.completed)' : '';
		} else {
			groupModalSelector += '.completed';
		}

		$siblingGroups = $productGroup.siblings(groupModalSelector);
		if (!$siblingGroups.length) {
			return;
		}

		// find next or previous product group
		// handle edges, when moving between first and last group
		var $groupToToggle = lookingNext ? $productGroup.next(groupModalSelector) : $productGroup.prev(groupModalSelector);
		if (!$groupToToggle.length) {
			$groupToToggle = lookingNext ? $siblingGroups.first() : $siblingGroups.last();
		}

		$productGroup.find('.toggle-modal').first().click();
		$groupToToggle.find('.toggle-modal').first().click();
	});

	// handle togglers
	$('.product-group').on('click', '.toggle-refinement, .refinement_filter', function () {
		$(this).toggleClass('expanded').parent().toggleClass('active');
		var $self = $(this);
		if ($self.hasClass('refinement_filter')) {
			$self.closest('.top-area').toggleClass('refinements_active');
		}
	});

	// handle filters selection
	$('.product-group').on('click', '.refinement-link', function (e) {
		e.preventDefault();
		if (!$(this).hasClass('disabled-ref')) {
			$(this).toggleClass('checked');
		}
		// collect filters selected and combine with product group data
		var $productGroup = $(this).closest('.product-group');
		var $selectedRefinements = $productGroup.find('.refinement-link.checked[data-refinement-id][data-refinement-value]');
		var selectedFilters = {};

		// collect selected refinements
		$selectedRefinements.each(function (i, el) {
			var refinementAttr = el.getAttribute('data-refinement-id');
			var refinementValue = el.getAttribute('data-refinement-value');
			if (!selectedFilters[refinementAttr]) {
				selectedFilters[refinementAttr] = refinementValue;
			} else {
				selectedFilters[refinementAttr] += '|' + refinementValue;
			}
		});

		// TODO: refactor into get request, to consider caching
		var url = $productGroup.find('[data-filters-url]').data('filters-url');
		$.ajax({
			url: url,
			type: 'POST',
			dataType:'json',
			contentType: 'application/json',
			data: JSON.stringify(selectedFilters),
			success: function (response) {
				if (response.error) {
					return console.error(response);
				}

				// hide products shown
				$productGroup.find('.product').removeClass('hidden').filter(function () {
					return response.products.indexOf(this.getAttribute('product-id')) < 0;
				}).addClass('hidden');
				var viewInfo = $productGroup.find('.showing-products-info');
				viewInfo.find('.current').html(response.products.length);
			},
			error: console.error
		});

	});

	// handle submit buttons interactions
	$('#nextStep').on('click', function () {
		moveToNextStep(true);
	});

	$('#EditSubscriptionForm button').on('click', function (e) {
		e.preventDefault();
		moveToNextStep();
	});

	$('#cancelEdit').on('click', function (e) {
		e.preventDefault();
		$('#EditSubscriptionForm').submit();
	});
}

/*
 * Check current step selections and update continue button state
 */
function updateActiveStepComplition () {

	var currentResult = getResultConfig();
	// check complition of currently active step

	var isStepCompleted = true;
	for (var i = currentResult.selections.length - 1, selectionData; i >= 0; i--) {
		selectionData = currentResult.selections[i];
		if (currentResult.activeStep === selectionData.step) {
			isStepCompleted = isStepCompleted && selectionData.completed;
		}
	}

	if (isStepCompleted) {
		$('#nextStep, #edit').removeClass('disabled');
		$('.product-group .product-group-content .close-and-view').addClass('completed-step');
	} else {
		$('.product-group .product-group-content .close-and-view').removeClass('completed-step');
	}

	return isStepCompleted;
}

/*
 * Check if there a selection avilable for current step and trigger it
 */
function triggerNextAvailableSelection (isNewSelection) {
	var nextSelection = getNextSelection();
	var currentResult = getResultConfig();
	var isSameStep = nextSelection && nextSelection.step === currentResult.activeStep;
	if (isSameStep) {
		moveToNextStep(isNewSelection);
	}
}

/*
 * Proceed to next available selection or submit configurator
 */
function moveToNextStep (isNewSelection) {
	var nextSelection = getNextSelection();
	if (!nextSelection) {
		proccessComplete();
		return;
	}

	// if there a data available, we will just activate that step
	var customerSelectionData = getSelection(nextSelection.step, nextSelection.id);
	if (customerSelectionData) {
		var currentResult = getResultConfig();
		currentResult.activeStep = nextSelection.step;
		updateConfiguratorViewSync();
		return;
	}

	// when moving to selection in the same step scroll it to visible
	updateSelection(nextSelection.step, nextSelection.id);

	// do not scroll in case of changing selection on desktop
	if (!isNewSelection && util.viewport.isStandard()) {
		return;
	}

	var sectionOffset = $('.selection').filter('[selection-id="' + nextSelection.id + '"]').offset();
	if (sectionOffset) {
		var scrollPosition = sectionOffset.top - $('.steps_description').height();
		window.scrollTo({
			top: scrollPosition,
			behavior: 'smooth'
		});
	}
}

/*
	Method to trigger configurator complete
	either submit configurator to add items
	or update subscription using provided edit data
*/
function proccessComplete () {
	var isEditMode = $('#nextStep').hasClass('edit-mode');
	if (!isEditMode) {
		window.location.href = $('#nextStep').data('submit-url');
		return;
	}

	var editItems = [];
	var editResult = {
		items: editItems
	};

	// adding all items into object
	// each individual product id, as own element
	var currentResult = getResultConfig();
	for (var i = 0, selectionData; i < currentResult.selections.length; i++) {
		selectionData = currentResult.selections[i];
		for (var productID in selectionData.items) {
			var qty = selectionData.items[productID];
			for (var q = 0; q < qty; q++) {
				editItems.push({
					product: productID
				});
			}
		}
	}

	$('#editStatus').val(editStatuses.OK);
	$('#editData').val(JSON.stringify(editResult));
	$('#EditSubscriptionForm').submit();
}
/*
	Find previous step from selections made, set it as active and update view
*/
function moveToPreviousStep() {
	var currentResult = getResultConfig();
	var stepID;
	for (var i = currentResult.selections.length - 1, selectionData; i >= 0; i--) {
		selectionData = currentResult.selections[i];
		// skip latest selections, that aren't active
		if (!stepID && currentResult.activeStep !== selectionData.step) {
			continue;
		}
		// then find next one
		stepID = stepID || selectionData.step;
		if (stepID !== selectionData.step) {
			stepID = selectionData.step;
			break;
		}
	}
	// handle case when button shown on first step
	if (!stepID) {
		return console.warn('Previous step not found');
	}

	// set as active and update view, scroll to active
	currentResult.activeStep = stepID;
	updateConfiguratorView();

	var sectionOffset = $('.selection').filter('[step-id="' + stepID + '"]').offset();
	if (sectionOffset) {
		var scrollPosition = sectionOffset.top - $('.steps_description').height();
		window.scrollTo({
			top: scrollPosition,
			behavior: 'smooth'
		});
	}
}

/*
 * Update summary section via ajax load
 * also update dynamic content slot
 */
function updateSummary () {
	var $summaryContent = $('#summaryContent');
	$summaryContent.addClass('loading');
	$summaryContent.load($summaryContent.data('load-url'), function () {
		$summaryContent.removeClass('loading');
		progress.hide();
	});

	var currentResult = getResultConfig();
	var stepConfig = getConfigData(configurator.data.constants.configTypeStep, currentResult.activeStep);
	$('.dynamic-content-slot').each(function () {
		var url = $(this).data('load-url');
		var slotID = stepConfig.slotID || $(this).data('slot-id');
		if (slotID) {
			url = util.appendParamToURL(url, 'slotID', slotID);
		}
		$(this).load(url);
	});
}

/*
 * Check if given selection should be displayed
 */
function isSelectionQualified(selectionID) {
	var selectionConfig = getConfigData(configurator.data.constants.configTypeSelection, selectionID);
	if (!selectionConfig.qualifiers || !selectionConfig.qualifiers.length) {
		return true;
	}

	var availableQualifiers = getQualifierSelections();
	for (var i = 0, productGroup; i < availableQualifiers.length; i++) {
		productGroup = availableQualifiers[i];
		if (selectionConfig.qualifiers.indexOf(productGroup) >= 0) {
			return true;
		}
	}

	// console.debug('Selection not available', selectionConfig, availableQualifiers);
	return false;
}

/*
 * Check if given selection completed and update related flags
 * each product group in selection checked
 * once all finished, selection flagged as completed
 */
function updateSelectionComplition(selectionData) {
	if (!selectionData.option || !selectionData.items) {
		return false;
	}

	// check option setup, as it may not require any products
	// in that case, product groups itraction will be skipped
	var selectedOptionData = getConfigData(configurator.data.constants.configTypeOption, selectionData.option);
	selectionData.completed = true;

	// go through product groups to check items in selection made
	for (var productGroupID in selectedOptionData.productGroups) {
		var groupQuantity = selectedOptionData.productGroups[productGroupID];
		selectionData.groupsCompletion[productGroupID] = checkProductGroupComplition(productGroupID, groupQuantity, selectionData.items);
		selectionData.completed = selectionData.completed && selectionData.groupsCompletion[productGroupID];
	}

	return selectionData.completed;
}

/*
 * Check items required for given product group and quantity
 * it can be 0, if no qty requirment present
 */
function checkProductGroupComplition(productGroupID, groupQuantity, items) {

	var productGroup = getConfigData(configurator.data.constants.configTypeProductGroup, productGroupID);
	// handle cases when quantity validation is not required - all or none required
	if (productGroup.type === configurator.data.constants.productGroupTypeAny ||
		productGroup.type === configurator.data.constants.productGroupTypeAll) {
		return true;
	}

	var itemsQuantity = 0;
	for (var productID in items) {
		if (!isItemInProductGroup(productID, productGroup)) {
			continue;
		}

		itemsQuantity += items[productID];
	}

	return itemsQuantity === groupQuantity;
}

/*
 * Check if product in product group
 */
function isItemInProductGroup(productID, productGroup) {
	var alternativeID = configurator.data.pidsMapping[productID];
	if (productGroup.pids.indexOf(productID) < 0 && productGroup.pids.indexOf(alternativeID) < 0) {
		return false;
	}

	return true;
}

/*
 * Update entire view of configurator page, using current selections made
 */
function updateConfiguratorView() {

	if (!configurator.data) {
		return console.error('Missing configurator data', configurator.data);
	}

	// reset view for all areas
	$('#nextStep, #edit').addClass('disabled');
	$('.step').removeClass('activeStep');
	$('.step_description').removeClass('visible');
	$('.selection').removeClass('visible').removeClass('completed');
	$('.option').removeClass('active').removeClass('disabled');
	$('.option-content').removeClass('visible');
	$('.product-group').removeClass('visible').removeClass('completed');
	$('.product[product-id]').removeClass('active');
	$('.product').find('input[name="quantity"]').val(0);
	$('.product').find('.option-select').removeClass('selected');
	$('.step-action').removeClass('activeStep');
	$('.configurator-container').removeClass('active').attr('step-style', '');
	$('.preview-control_info .number').text(0);
	$('.next-selection-btn, .prev-selection-btn').addClass('disabled');

	// reset bubles in product group
	$('.product-group .chosen-items .chosen-selection').each(function () {
		$(this).removeClass('filled');
		var previewImage = $(this).find('img');
		previewImage.attr('src', previewImage.data('bg'));
	});
	updateTooltip(); // reset tooltip

	var currentResult = getResultConfig();
	var latestStep, selectionData;
	// iterate from latest step
	for (var i = currentResult.selections.length - 1; i >= 0; i--) {
		selectionData = currentResult.selections[i];
		latestStep = latestStep || selectionData.step;
		// flag what areas shown
		if (currentResult.activeStep === selectionData.step) {
			showSection(selectionData);
		} else if (latestStep !== selectionData.step) {
			// flag completed sections
			applySelection(selectionData);
		}
	}
	// updating product groups view
	// should be triggered after classes update/resize
	updateProductGroupContent();
	updateActiveStepComplition();
}

/*
 * Show sections based on given selection
 */
function showSection (selectionData) {
	var selectedStepData = getConfigData(configurator.data.constants.configTypeStep, selectionData.step);
	$('.step').filter('[step-id="' + selectionData.step + '"]').addClass('activeStep');
	$('.configurator-container').attr('step-style', selectedStepData.style);

	$('.step-action').filter('[stepbtn-id="' + selectionData.step + '"]').addClass('activeStep');

	$('.step_description').filter('[step-id="' + selectionData.step + '"]').addClass('visible');
	var $summarySection = $('.right_container');
	$summarySection.addClass('visible');

	// find sections that should be presented
	var $selection = $('.selection').filter('[selection-id="' + selectionData.selection + '"]');
	$selection.addClass('visible');

	if (selectionData.completed) {
		$selection.addClass('completed');
	}

	var selectionConfig = getConfigData(configurator.data.constants.configTypeSelection, selectionData.selection);
	updateTooltip(selectionConfig['tooltip-message']);

	// following logic only applicable with option selected
	if (!selectionData.option) {
		return;
	}

	// activate selected option
	$('.configurator-container').addClass('active');
	$('.option').filter('[for="' + selectionData.option + '"]').addClass('active');
	// change required for select input to update label, event should be prevented inside with value check
	$selection.find('select[name="option"]').val(selectionData.option).change();

	// unblock some areas after selections
	if ($('.option').hasClass('active')) {
		$('#nextStep').removeClass('not-reached');
	}

	// display related option content
	$('.option-content').filter('[option-id="' + selectionData.option + '"]').addClass('visible');

	// update tooltip content, or reset once step completed
	var selectedOptionData = getConfigData(configurator.data.constants.configTypeOption, selectionData.option);
	updateTooltip(!selectionData.completed ? selectedOptionData['tooltip-message'] : '');

	for (var productGroupID in selectedOptionData.productGroups) {
		var productGroup = getConfigData(configurator.data.constants.configTypeProductGroup, productGroupID);
		var productGroupQty = selectedOptionData.productGroups[productGroupID];
		var $productGroup = $selection.find('.product-group').filter('[product-group-id="' + productGroupID + '"]');
		$productGroup.addClass('visible');
		$productGroup.attr('group-qty', productGroupQty);
		if (!$productGroup.hasClass('loaded')) {
			continue;
		}

		// check if there bubles needs to be added
		// copy empty bubles up to qty of items
		$productGroup.find('.chosen-items').each(function () { // eslint-disable-line no-loop-func
			var $bubles = $(this).children();
			for (var i = $bubles.length; i < productGroupQty; i++) {
				$(this).append($bubles.first().clone());
			}
		});

		var itemQuantity, $product;
		var totalItemsQuantity = 0;
		for (var productID in selectionData.items) {
			itemQuantity = selectionData.items[productID];
			$product = $productGroup.find('[product-id="' + productID + '"], [pid="' + productID + '"]');
			// skip products are not part of product group
			if (!$product.length) {
				continue;
			}

			// adding product classes to reflect selection
			totalItemsQuantity += itemQuantity;
			$product.addClass('active');
			$product.find('input[name="quantity"]').val(itemQuantity);
			// not handling variation switch, but product id added with content asset, so it can be aligned to match with config
			$product.find('.option-select[product-id="' + productID + '"]').addClass('selected');

			// updating bubles and related interactions
			var productImgSrc = $product.find('img').attr('src');
			$productGroup.find('.chosen-items').each(function () { // eslint-disable-line no-loop-func
				for (var k = 0; k < itemQuantity; k++) {
					var $emptyBuble = $(this).find('.chosen-selection:not(.filled)').first();
					$emptyBuble.addClass('filled');
					$emptyBuble.find('img').attr('src', productImgSrc);
					$emptyBuble.attr('buble-pid', productID);
				}
			});
		}

		// update group qty label
		$productGroup.find('.preview-control_info .current').text(totalItemsQuantity);

		// if no items available for that group check to show at least first option
		if ((!itemQuantity || !$product.length) && productGroup.type === configurator.data.constants.productGroupTypeOneOption) {
			$productGroup.find('.product').first().addClass('active');
		}

		// update product group complition
		if (selectionData.groupsCompletion[productGroupID]) {
			$productGroup.addClass('completed');
			$productGroup.closest('.selection').find('.option').not('.active').addClass('disabled');
		}
	}
}

/*
 * Method called for all previous step selections
 * Flag customer selections as completed
 */
function applySelection(selectionData) {
	$('.step').filter('[step-id="' + selectionData.step + '"]').addClass('completedStep');
}

/*
 * Helper method to get particular configuration data by type and id
 */
function getConfigData(type, id) {
	var result;
	switch (type) {
		case configurator.data.constants.configTypeStep:
			for (var i = 0, step; i < configurator.data.steps.length; i++) {
				step = configurator.data.steps[i];
				if (step.id === id) {
					result = step;
					break;
				}
			}
			break;
		case configurator.data.constants.configTypeSelection:
			result = configurator.data.selections[id];
			break;
		case configurator.data.constants.configTypeOption:
			result = configurator.data.options[id];
			break;
		case configurator.data.constants.configTypeProductGroup:
			result = configurator.data.productGroups[id];
			break;
	}

	if (!result) {
		console.error('data not found', type, id);
	}

	return result;
}

/*
 * Get latest selection data
 * within the active step or all selections
 */
function getLatestSelection(inActiveStep) {
	var currentResult = getResultConfig();
	for (var i = currentResult.selections.length - 1, selectionData; i >= 0; i--) {
		selectionData = currentResult.selections[i];
		// skip not active steps selections
		if (inActiveStep && currentResult.activeStep !== selectionData.step) {
			continue;
		}

		return selectionData;
	}
	return null;
}

/*
 * Check selections available
 * return latest that should be displayed or null
 */
function getNextSelection() {
	var latestSelection = getLatestSelection(true);
	var nextAvilableSelection, stepFound = !latestSelection ? true : false;
	// search through all selections to find one that is available next to latest selection
	for (var i = 0, selectionData; i < configurator.data.selectionsList.length; i++) {
		selectionData = configurator.data.selectionsList[i];
		if (!stepFound && latestSelection.step === selectionData.step && latestSelection.selection === selectionData.id) {
			stepFound = true;
			continue;
		}
		if (stepFound && isSelectionQualified(selectionData.id)) {
			nextAvilableSelection = selectionData;
			break;
		}
	}
	return nextAvilableSelection;
}

/*
 * Select items from Box whitch is editing now
 */
function getPreselectItems () {
	var editData = getEditConfig();
	var items = {};
	if (!editData || !editData.items) {
		return items;
	}

	return editData.items;
}

$(document).ready(function () {
	configurator.init();
	global.init();
	if (SitePreferences.GTM_ENABLED && window.pageContext.ns) {
		googletaglinchpin.init(window.pageContext.ns);
	}
});